import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const ScrollToTop = () => {
    const { pathname } = useLocation();

    // Prevent browser from restoring scroll position on reload
    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
